import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlreadyAuthenticatedGuard } from './guards/already-authenticated.guard';

@NgModule({
  declarations: [],
  providers: [AlreadyAuthenticatedGuard],
  imports: [CommonModule],
  exports: [],
})
export class SharedModule {}
